module.exports = __webpack_public_path__ + "static/media/EmptyIcon.b2477538.svg";